import { useEffect, useState } from 'react';

export const useLinkData = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const getPayload = () => {
      const { hostname, pathname } = window.location;
      const parts = hostname.split('.');
      const [sub, domain] = parts.length > 2 ? parts : ['', parts[0]];
      const [_, companyTag, locationTag] = pathname.split('/');

      return {
        domain: domain || '',
        sub: sub || '',
        companyTag: companyTag || '',
        locationTag: locationTag || '',
      };
    };

    const applyTheme = (theme) => {
      if (!theme) return;
      const root = document.documentElement;
      root.style.setProperty('--accent', `#${theme.colors.Accent}`);
      root.style.setProperty('--linkhover', `#${theme.colors.LinkHover}`);
      root.style.setProperty('--bg-light', `#${theme.colors.BgLight}`);
    };

    const fetchData = async () => {
      try {
        const payload = getPayload();
        //const res = await fetch('https://localhost:7123/api/links/general', {
        const res = await fetch('https://masterpiece-prod-csftcwdvg2ecfmfr.westeurope-01.azurewebsites.net/api/links/general', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const json = await res.json();
        setData(json);
        applyTheme(json.theme);
        document.title = json.name + " | " + json.tagline;
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  return data;
};